import React, { useState, useEffect } from 'react';

/* Style & Assets */
import style from '../assets/style/BottomNavbar.module.css';

import HomeTrue from '../assets/home-true.svg';
import HomeFalse from '../assets/home-false.svg';

import PlusImage from '../assets/plus.svg';
import BellImage from '../assets/bell.svg';

import ProfileTrue from '../assets/profile-true.svg';
import ProfileFalse from '../assets/profile-false.svg';
import { Link } from 'react-router-dom';
import { getNotificationCache } from '../hooks/useNotificationPreloader';

const BottomNavbar = (props) => {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (props.user) {
      // Poll for unread count updates
      const updateCount = () => {
        const cache = getNotificationCache();
        setUnreadCount(cache.unreadCount || 0);
      };

      updateCount();
      const interval = setInterval(updateCount, 2000);
      return () => clearInterval(interval);
    }
  }, [props.user]);

  return (
    <div className={style.bottomNavbar}>
      {props.currentPage === 'home' ? (
        <img src={HomeTrue} alt="Home" onClick={props.toTop} />
      ) : (
        <Link to={'/feed'}>
          <img src={HomeFalse} alt="Home" />
        </Link>
      )}
      {
        <Link to={'/newpost'}>
          <img src={PlusImage} alt={'Create Post'} />
        </Link>
      }
      {props.currentPage === 'profile' ? (
        <img src={ProfileTrue} alt="Profile" />
      ) : (
        <Link to={'/profile/' + props.userID}>
          <img src={ProfileFalse} alt="Profile" />
        </Link>
      )}
      <Link to={'/notifications'} className={style.notificationWrapper}>
        <img src={BellImage} alt="Notifications" />
        {unreadCount > 0 && (
          <span className={style.notificationBadge}>
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </Link>
    </div>
  );
};

export default BottomNavbar;
